import React from 'react';
import BookstoreLayout from '../bookstore-layout';
import Layout from '../../layout';

const TrainingDownloadsLayout: React.FC = ({ children }) => (
  <Layout title="Training Downloads">
    <BookstoreLayout
      title="Training Digital Downloads"
      subtitle=""
      breadcrumb={{ url: '/training', text: 'Back' }}
      hero=""
    >
      {children}
    </BookstoreLayout>
  </Layout>
);

export default TrainingDownloadsLayout;
